import { render, staticRenderFns } from "./TradingPanel.vue?vue&type=template&id=510e09b5&scoped=true"
import script from "./TradingPanel.vue?vue&type=script&lang=js"
export * from "./TradingPanel.vue?vue&type=script&lang=js"
import style0 from "./TradingPanel.vue?vue&type=style&index=0&id=510e09b5&prod&scoped=true&lang=css"
import style1 from "./TradingPanel.vue?vue&type=style&index=1&id=510e09b5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510e09b5",
  null
  
)

export default component.exports